import { Reset } from "@bluframe/blublocks"
import styled from "styled-components"
import colors from "styles/colors"

export const ButtonGroup = styled.div`
  display: grid;
  column-gap: 6px;
  grid-template-columns: 1fr 1fr;
  opacity: 0;
  transition: opacity 0.25s ease-in-out;
`

export const ListItem = styled(Reset.Li)`
  background: ${colors.white};
  display: grid;
  grid-template-columns: 1fr auto;

  &:hover ${ButtonGroup} {
    opacity: 1;
  }
`
